import { Object3D } from "three";
import { FrontElementObject } from "./FrontElementObject";

export class FrontFaceObject extends Object3D {

    public FrontElements: FrontElementObject[] = [];

    constructor() {
        super();
    }
}
